export enum PaymentStatus {
    NOT_PAID_UPCOMING = "NOT_PAID_UPCOMING",
    NOT_PAID_OVERDUE = "NOT_PAID_OVERDUE",
    PAID_PARTIALLY = "PAID_PARTIALLY",
    PAID_OVERDUE = "PAID_OVERDUE",
    PAID_ON_TIME = "PAID_ON_TIME"
}
type PaymentStatusTypeRecord = Record<PaymentStatus, string>;

export const PaymentStatusTypeMapped: PaymentStatusTypeRecord = {
  [PaymentStatus.NOT_PAID_UPCOMING]: "Предстоящий",
  [PaymentStatus.NOT_PAID_OVERDUE]: "В просрочке",
  [PaymentStatus.PAID_PARTIALLY]: "Оплачен частично",
  [PaymentStatus.PAID_OVERDUE]: "Оплачен с просрочкой",
  [PaymentStatus.PAID_ON_TIME]: "Оплачен",
};

export const translatePaymentStatusType = (type: PaymentStatus): string => {
  return PaymentStatusTypeMapped[type];
};